module.exports = __webpack_public_path__ + "2dd809977cf883c49caa315b5e81c288.svg";